import { useSWRConfig } from "swr";
import useMutation from "hooks/useMutation";
import OneRepMaxService from "services/OneRepMaxService";
import { getOneRepMaxesByAthleteIdsCacheKeyMatcher } from "hooks/useGetOneRepMaxesByAthleteIdsQuery";
import { getAthleteOneRepMaxesCacheKeyMatcher } from "hooks/useGetAthleteOneRepMaxesQuery";
import type { OneRepMaxesCreate, OneRepMaxValue } from "types/onerepmax";

const key = "OneRepMaxService.createMany";

/**
 * Creates dated 1RMs for one or more athletes in a single request, then revalidates every cached 1RM list that
 * could include them, since a backdated entry can land in any range.
 */
function useOneRepMaxCreateManyMutation() {
  const { mutate } = useSWRConfig();

  return useMutation<Pick<OneRepMaxValue, "id">[], Error, string, OneRepMaxesCreate[]>(key, async (_, { arg }) => {
    const created = await OneRepMaxService.createMany(arg);
    const matchers = [
      getOneRepMaxesByAthleteIdsCacheKeyMatcher(),
      ...arg.map(({ athleteId }) => getAthleteOneRepMaxesCacheKeyMatcher(athleteId)),
    ];
    await mutate((cacheKey) => matchers.some((matches) => matches(cacheKey)));
    return created;
  });
}

export default useOneRepMaxCreateManyMutation;
